import { render, staticRenderFns } from "./LHome.vue?vue&type=template&id=64bdf440&"
import script from "./LHome.vue?vue&type=script&lang=js&"
export * from "./LHome.vue?vue&type=script&lang=js&"
import style0 from "./LHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports